export enum AdditionalDataKeyApiUrls {
  GetAdditionalDataKeys = '/api/TenantSystemKey/GetTenantSystemKeys',
  GetAdditionalDataKey = '/api/TenantSystemKey/GetTenantSystemKey',
}
